var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRocketreac = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    fill: "none",
    viewBox: "0 0 27 27",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#22262A",
    d: "M13.129 25.84c7.014 0 12.715-5.701 12.715-12.715S20.143.41 13.129.41.414 6.111.414 13.125 6.115 25.84 13.13 25.84m-9.844-7.65 5.168-.04a18.4 18.4 0 0 0 2.85 5.885c-3.506-.574-6.439-2.81-8.018-5.845m6.48-8.551h6.44c.472 2.256.472 4.573.041 6.829l-6.48.04a16.9 16.9 0 0 1 0-6.87m3.22 13.925a16.5 16.5 0 0 1-2.81-5.415l5.64-.04a17.3 17.3 0 0 1-2.83 5.454m1.641.533a18.1 18.1 0 0 0 2.892-6.01l5.516-.04a11.1 11.1 0 0 1-8.408 6.05m9.577-10.972c0 1.148-.184 2.256-.492 3.281l-5.804.041c.41-2.256.39-4.552-.04-6.808h5.762c.369 1.087.574 2.276.574 3.486m-1.271-5.127h-5.455a18.9 18.9 0 0 0-2.851-5.845 11.03 11.03 0 0 1 8.306 5.845m-7.158 0h-5.578a17 17 0 0 1 2.79-5.311 17 17 0 0 1 2.788 5.311m-4.47-5.783a18.2 18.2 0 0 0-2.81 5.783H3.326a11.04 11.04 0 0 1 7.978-5.783m-3.2 7.424a18.9 18.9 0 0 0-.02 6.87l-5.476.04a10.6 10.6 0 0 1-.553-3.424c0-1.21.205-2.4.574-3.486z"
  })));
};
export default SvgRocketreac;